//import { useState } from "react";
import {
  useColorModeValue,
  chakra,
  useDisclosure,
  Flex,
  HStack,
  Button,
  Box,
  IconButton,
  VStack,
  CloseButton,
  Text,
  useToast
} from '@chakra-ui/react';
import React from 'react';
import { AiOutlineShoppingCart, AiOutlineMenu } from 'react-icons/ai';
import { Link } from 'react-router-dom';
import { useCtx } from '../context/AppContext';
import Logo from '../Logo';
import WrapContent from './WrapContent';
//import useContract from '../hooks/useContracts';


function Navbar() {
  const { connect, disconnect, auth, isConnected } = useCtx();
  const bg = useColorModeValue('white', 'gray.800');
  const mobileNav = useDisclosure();

  return (
    <React.Fragment>
      <chakra.header
        bg={'teal'}
        w="full"
        px={{
          base: 2,
          sm: 4,
        }}
        py={4}
        shadow="md"
      >
        <WrapContent>
          <Flex alignItems="center" justifyContent="space-between" mx="auto">
            <Flex>
              <Logo />
            </Flex>
            <HStack display="flex" alignItems="center" spacing={1}>
              <HStack
                spacing={1}
                mr={3}
                color="gray.100"
                display={{
                  base: 'none',
                  md: 'inline-flex',
                }}
              >
                <Button
                  _hover={{
                    color: 'black',
                  }}
                  variant="ghost"
                  as={Link}
                  to="/products"
                >
                  Products
                </Button>
                <Button
                  _hover={{
                    color: 'black',
                  }}
                  variant="ghost"
                  as={Link}
                  to="/merchant"
                >
                  Merchant zone
                </Button>
                {!auth && (
                  <Button
                    _hover={{
                      color: 'black',
                    }}
                    variant="ghost"
                    as={Link}
                    to="/signin"
                  >
                    SignIn
                  </Button>
                )}
                {auth && (
                  <Button
                    _hover={{
                      color: 'red',
                    }}
                    variant="ghost"
                    onClick={() => {
                      localStorage.removeItem('merchantdata');
                      window.location.reload();
                    }}
                  >
                    Sign Out
                  </Button>
                )}
                <CartBtn />
              </HStack>
              {isConnected ? <Button
                _hover={{
                  color: 'black',
                }}
                colorScheme="brand"
                size="sm"
                onClick={disconnect}
              >
                Disconnect
              </Button> :
              <Button
                _hover={{
                  color: 'black',
                }}
                colorScheme="brand"
                size="sm"
                onClick={connect}
              >
                Connect
              </Button>
              }
              <Box
                display={{
                  base: 'inline-flex',
                  md: 'none',
                }}
              >
                <CartBtn />

                <IconButton
                  display={{
                    base: 'flex',
                    md: 'none',
                  }}
                  aria-label="Open menu"
                  fontSize="20px"
                  color="gray.800"
                  _dark={{
                    color: 'inherit',
                  }}
                  variant="ghost"
                  icon={<AiOutlineMenu />}
                  onClick={mobileNav.onOpen}
                />

                <VStack
                  pos="absolute"
                  top={0}
                  left={0}
                  right={0}
                  display={mobileNav.isOpen ? 'flex' : 'none'}
                  flexDirection="column"
                  p={2}
                  pb={4}
                  m={2}
                  zIndex="10"
                  bg={bg}
                  spacing={3}
                  rounded="sm"
                  shadow="sm"
                >
                  <CloseButton
                    aria-label="Close menu"
                    onClick={mobileNav.onClose}
                  />

                  <Button variant="ghost" w="full" as={Link} to="/products">
                    Products
                  </Button>
                  <Button variant="ghost" w="full" as={Link} to="/signup">
                    SignUp
                  </Button>
                  <Button w="full" as={Link} to="/signin" variant="ghost">
                    Sign in
                  </Button>
                  <CartBtn />
                </VStack>
              </Box>
            </HStack>
          </Flex>
          <Text fontSize="sm" textAlign={'center'} pt="2" color="gray.200">
            Your No 1. Marketplace to buy anything with Your crypto...
          </Text>
        </WrapContent>
      </chakra.header>
    </React.Fragment>
  );
}

export default Navbar;

function CartBtn() {
  const { cart } = useCtx();

  return (
    <Box pos="relative">
      <Box pos="absolute" color="yellow" top="0" right="0">
        {cart.length}
      </Box>
      <IconButton
        as={Link}
        to="/cart"
        fontSize="24px"
        color="white"
        icon={
          <>
            <AiOutlineShoppingCart />
          </>
        }
        variant="flushed"
        _hover={{
          color: 'gray.700',
        }}
        _focus={{
          boxShadow: 'none',
        }}
      />
    </Box>
  );
}
